import type { ReactNode } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import type { UserMenuSubject } from './types';

interface UserMenuCompanyCardProps {
  company: UserMenuSubject;
  /** Slot under the company name — the client app puts its "View profile" link here. */
  children?: ReactNode;
}

/** Names the company the session is scoped to. */
export function UserMenuCompanyCard({
  company,
  children,
}: UserMenuCompanyCardProps) {
  return (
    <div className='px-3 py-2.5 bg-muted/30'>
      <div className='flex items-center gap-2.5'>
        <Avatar className='h-9 w-9 shrink-0'>
          <AvatarImage src={company.imageUrl} alt={company.name} />
          <AvatarFallback
            delay={0}
            className='bg-primary text-primary-foreground text-sm font-semibold'
          >
            {company.initials}
          </AvatarFallback>
        </Avatar>
        <div className='min-w-0 flex-1'>
          <p className='text-sm font-semibold truncate'>{company.name}</p>
          {children}
        </div>
      </div>
    </div>
  );
}
